import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { Text, Skeleton, Alert } from '@grandvisionhq/iris-ui';
import '../../../models/cart/cart-state.js';
import '../../../models/checkout/checkout-step-error-type.js';
import '../../../models/checkout-settings.js';
import { ShippingMethod } from '../../../models/step-shipping/shipping-methods.js';
import '../../../models/shared.js';
import '@grandvisionhq/icons';
import '@swc/helpers';
import '@grandvisionhq/state';
import '@grandvisionhq/locations';
import { ShippingMethodsList } from '../../modules/ShippingMethods/components/ShippingMethodsList.js';
import { ShippingMethodPlaceholder } from './components/ShippingMethodPlaceholder.js';
import { useGroupedShippingMethods } from './hooks/use-grouped-shipping-methods.js';

const AlternativeShippingMethodsList = ({ labels , onSubmit , onChange , onModalClose , selectedShippingMethod  })=>{
    const homeDeliveryShippingMethodGroups = React.useMemo(()=>{
        const sharedGroup = [
            ShippingMethod.Delivery,
            ShippingMethod.DeliveryExpress,
            ShippingMethod.DeliveryPremium, 
        ];
        return Object.fromEntries(sharedGroup.map((method)=>[
                method,
                sharedGroup
            ]
        ));
    }, []);
    const allowedKeys = React.useMemo(()=>{
        return (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method) ? homeDeliveryShippingMethodGroups[selectedShippingMethod.method] || [
            selectedShippingMethod.method, 
        ] : [];
    }, [
        selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method,
        homeDeliveryShippingMethodGroups
    ]);
    const handleCompleted = React.useCallback((shippingMethods)=>{
        const filteredShippingMethods = shippingMethods.filter((item)=>allowedKeys.includes(item.key)
        );
        if (filteredShippingMethods.length === 0) {
            onSubmit();
        }
    }, [
        allowedKeys,
        onSubmit
    ]);
    const { groupedShippingMethods , error , isLoading  } = useGroupedShippingMethods(allowedKeys, handleCompleted);
    const shippingMethodsList = React.useMemo(()=>groupedShippingMethods.filter((item)=>allowedKeys.includes(item.value)
        )
    , [
        allowedKeys,
        groupedShippingMethods
    ]);
    const hasValidationError = !(selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isValid) && (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isTouched);
    const handleChange = (shippingMethodKey)=>{
        const shippingMethod = groupedShippingMethods.find((item)=>item.value === shippingMethodKey
        );
        onChange(shippingMethod);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "alternative-shipping-methods"
    }, isLoading && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, {
        color: "text-secondary"
    }, labels.description), /*#__PURE__*/ React.createElement(ShippingMethodPlaceholder, null), /*#__PURE__*/ React.createElement(ShippingMethodPlaceholder, null), /*#__PURE__*/ React.createElement(ShippingMethodPlaceholder, null), /*#__PURE__*/ React.createElement("div", {
        className: "alternative-shipping-methods__button-placeholder"
    }, /*#__PURE__*/ React.createElement(Skeleton, {
        height: 48,
        width: "100%",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "100%",
        rx: "4",
        height: "48px",
        fill: "currentColor"
    })))), error && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Alert, {
        variant: "error",
        title: labels.errorTitle
    }, labels.errorDescription), /*#__PURE__*/ React.createElement(Button, {
        variant: "outline",
        caption: labels.back,
        onClick: onModalClose
    })), !isLoading && (shippingMethodsList === null || shippingMethodsList === void 0 ? void 0 : shippingMethodsList.length) > 0 && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, null, labels.description), /*#__PURE__*/ React.createElement(ShippingMethodsList, {
        handleChange: handleChange,
        shippingMethodItems: shippingMethodsList,
        selectedShippingMethod: (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method) ? selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method : '',
        hasValidationError: hasValidationError
    }), /*#__PURE__*/ React.createElement(Button, {
        style: {
            width: '100%'
        },
        caption: labels.buttonCaptionLabel,
        onClick: onSubmit
    })));
};

export { AlternativeShippingMethodsList };
//# sourceMappingURL=AlternativeShippingMethodsList.js.map
